/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_EngineInputs */

const en_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG Engine`)
};

const es_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor RAG`)
};

const fr_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur RAG`)
};

const de_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG-Engine`)
};

const ja_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAGエンジン`)
};

const zh_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG 引擎`)
};

const ar_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محرك RAG`)
};

const id_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesin RAG`)
};

const it_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motore RAG`)
};

const ru_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Движок RAG`)
};

const pt_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mecanismo RAG`)
};

const ko_rag_engine = /** @type {(inputs: Rag_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG 엔진`)
};

/**
* | output |
* | --- |
* | "RAG Engine" |
*
* @param {Rag_EngineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rag_engine = /** @type {((inputs?: Rag_EngineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_EngineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rag_engine(inputs)
	if (locale === "es") return es_rag_engine(inputs)
	if (locale === "fr") return fr_rag_engine(inputs)
	if (locale === "de") return de_rag_engine(inputs)
	if (locale === "ja") return ja_rag_engine(inputs)
	if (locale === "zh") return zh_rag_engine(inputs)
	if (locale === "ar") return ar_rag_engine(inputs)
	if (locale === "id") return id_rag_engine(inputs)
	if (locale === "it") return it_rag_engine(inputs)
	if (locale === "ru") return ru_rag_engine(inputs)
	if (locale === "pt") return pt_rag_engine(inputs)
	return ko_rag_engine(inputs)
});